import { tokens } from "@planningcenter/tapestry-tokens/tokens"

export function token<T extends keyof typeof tokens>(varName: T) {
  return `var(${varName})` as const
}

export function computedToken<T extends keyof typeof tokens>(varName: T) {
  return tokens[varName] as (typeof tokens)[T]
}
